module.exports = __webpack_public_path__ + "img/logo_white.86daa7bd.png";